<template>
    <div class="booking-wizard-header">
        <div class="row">
            <h1>{{ i18n.t('title') }}</h1>
            <TimeTicker />
        </div>
        <div class="row">
            <template v-if="stepsStore.prevStep && !hasFinishedAllSteps">
                <div class="step-back" @click="stepsStore.goToPrevStep">{{ i18n.t('navigation.prev') }}</div>
                <!-- TODO: Font awesome icon: 'fas', 'arrow-left' -->
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import TimeTicker from '@/widgets/Wizard/components/wizard/time-ticker.vue';
import { useStepsStore } from '@/widgets/Wizard/stores/steps';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const i18n = useI18n();

const stepsStore = useStepsStore();
const { completedStepsAmount, totalStepsAmount } = storeToRefs(stepsStore);

const hasFinishedAllSteps = computed(() => {
    return completedStepsAmount.value === totalStepsAmount.value;
});
</script>
